import { validateUrl } from "@lhd/features/Apps/utils";
import { Cell, CellStyle } from "@silevis/reactgrid";
import {
  CellTemplate,
  Compatible,
  Uncertain,
  getCellProperty,
  keyCodes,
} from "@silevis/reactgrid";
import React from "react";

export interface IndexCell extends Cell {
  type: "index";
  text: string;
  value?: number;
  nonEditable?: boolean;
  groupId?: number | string;
  style?: CellStyle;
  className?: string;
}

// IndexCellTemplate.tsx

export class IndexCellTemplate implements CellTemplate<IndexCell> {
  getCompatibleCell(
    uncertainCell: Uncertain<IndexCell>,
  ): Compatible<IndexCell> {
    return {
      ...uncertainCell,
      value: NaN,
      text: getCellProperty(uncertainCell, "text", "string"),
    };
  }

  render(cell: Compatible<IndexCell>, isSelected: boolean): React.ReactNode {
    return (
      <div
        style={{
          width: "100%",
          textAlign: "center",
        }}
      >
        {cell.text}
      </div>
    );
  }
}
